import script from "./StudentProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentProfile.vue?vue&type=script&setup=true&lang=js"

import "./StudentProfile.vue?vue&type=style&index=0&id=2a0154f8&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a0154f8"]])

export default __exports__